import styled, { keyframes } from 'styled-components'

export const loaderDelay = 0.4

const rotate = keyframes`
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
`

export const Spinner = styled.div`
	width: 32px;
	height: 32px;
	margin: 16px;
	border-radius: 50%;

	border: 4px solid rgba(51, 51, 51, 0.2);
	border-bottom-color: #333;

	animation: ${rotate} 0.8s linear infinite;
`

export const Loader = styled.div.attrs({
	children: <Spinner />,
})<{ isVisible: boolean }>`
	position: fixed;
	top: 50%;
	left: 50%;
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: #FFF;
	transform: translate(-50%, -50%);
	z-index: 100;
	pointer-events: none;

	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

	transition: opacity ${loaderDelay}s;
`
